import { head, isEmpty } from 'lodash/fp';

import { GET_TOC_ANNOUNCEMENTS } from '../../../src/client/models/table-of-contents/queries.gql';
import getCmsData from '../../../src/client/cms/utils/get-cms-data';

const HOME_PAGE_ANNOUNCEMENTS_IDENTIFIER = 'announcements';

const getAnnouncementsQuery = async (identifier = HOME_PAGE_ANNOUNCEMENTS_IDENTIFIER) => {
  const cmsAnnouncementsData = await getCmsData(GET_TOC_ANNOUNCEMENTS, {
    variables: { identifier },
  });
  const announcementItems = head(cmsAnnouncementsData?.allTableOfContentsList)?.items;
  return !isEmpty(announcementItems) ? announcementItems : null;
};

export default getAnnouncementsQuery;
